const COMPONENT_NAME = "BackToTopLink";
export {
  COMPONENT_NAME
};
